import { useState } from 'react'
import { PageHeader, Panel, EmptyState, Button, Textarea, useToast } from '../../ds/index'
import { useApi } from '../../lib/useApi'
import { post } from '../../lib/api'
import { LoadingBlock, ErrorBlock } from '../../components/Loading'
import { MessageList } from '../../components/OwnerMessages'

type Thread = { rep_id: string; rep_name: string; messages: { id: string; from_owner: boolean; body: string; created_at: string }[] }

/** What the responders recommending this business have asked it, and its answers. */
export default function ClientMessages() {
  const { data, error, reload } = useApi<{ threads: Thread[] }>('/api/client/messages')
  if (error) return <ErrorBlock error={error} />
  if (!data) return <LoadingBlock />
  return (
    <>
      <PageHeader title="Messages" subtitle="The responders recommending you can ask you things here. What you tell them helps them recommend you." />
      {data.threads.length === 0
        ? <EmptyState title="No messages yet" body="When a responder has a question for you, it shows up here and we email you." />
        : <div className="stack">{data.threads.map((t) => <ThreadPanel key={t.rep_id} thread={t} onSent={reload} />)}</div>}
    </>
  )
}

function ThreadPanel({ thread, onSent }: { thread: Thread; onSent: () => void }) {
  const toast = useToast()
  const [text, setText] = useState('')
  const [busy, setBusy] = useState(false)
  const send = async () => {
    setBusy(true)
    try { await post('/api/client/messages', { rep_id: thread.rep_id, body: text }); setText(''); onSent(); toast('Sent', 'pos') }
    catch (e) { toast((e as Error).message, 'neg') } finally { setBusy(false) }
  }
  return (
    <Panel>
      <div className="panel-header"><h2 className="panel-title">{thread.rep_name}</h2></div>
      <div className="owner-thread">
        <MessageList messages={thread.messages} mine={(m) => m.from_owner} theirName={thread.rep_name} />
        <Textarea rows={2} aria-label={`Answer ${thread.rep_name}`} placeholder="Your answer" value={text} onChange={(e) => setText(e.target.value)} />
        <div><Button onClick={send} disabled={busy || !text.trim()}>{busy ? 'Sending' : 'Send'}</Button></div>
      </div>
    </Panel>
  )
}
